export default __webpack_public_path__ + "static/media/banker_win.65b1e6f7.mp3";